export const getPortfolioPlanFrequencies = (subscriptionPlans = []) => {
  const planFrequency = [];
  subscriptionPlans.forEach((plan) => {
    if (!planFrequency.includes(plan.planFrequency)) {
      planFrequency.push(plan.planFrequency);
    }
  });
  return planFrequency.reverse();
};

export const pickPortfolioPlanForAmount = (
  subscriptionPlans = [],
  { amount, frequency, preferredPlanId } = {},
) => {
  if (!subscriptionPlans.length) {
    return null;
  }

  if (preferredPlanId) {
    const existing = subscriptionPlans.find(
      (plan) => Number(plan.planId) === Number(preferredPlanId),
    );
    if (existing) {
      return existing;
    }
  }

  const selectedFreq = frequency || "YEARLY";
  const freqPlans = subscriptionPlans.filter(
    (plan) => plan.planFrequency === selectedFreq,
  );
  const searchPlans = freqPlans.length ? freqPlans : subscriptionPlans;

  let autoSelectedPlan = null;

  if (amount) {
    searchPlans.some((plan) =>
      plan.productMap?.some((product) => {
        if (
          product.productCode === "PORTFOLIO" ||
          product.productCode === "PRIME"
        ) {
          if (
            product.aumLimit === -1 ||
            Number(amount) <= Number(product.aumLimit)
          ) {
            autoSelectedPlan = plan;
            return true;
          }
        }
        return false;
      }),
    );
  }

  return autoSelectedPlan || searchPlans[0] || subscriptionPlans[0];
};

export const resolvePortfolioSelectedPlan = (
  subscriptionPlans = [],
  { planId, investmentAmount, frequency } = {},
) => {
  if (!subscriptionPlans.length) {
    return null;
  }

  if (planId) {
    const matchedPlan = subscriptionPlans.find(
      (plan) => Number(plan.planId) === Number(planId),
    );
    if (matchedPlan) {
      return matchedPlan;
    }
  }

  return pickPortfolioPlanForAmount(subscriptionPlans, {
    amount: investmentAmount,
    frequency,
    preferredPlanId: planId,
  });
};

export const getPlanDisplayPrice = (plan) => {
  if (!plan) {
    return null;
  }

  const discountedPrice = Number(plan.planDiscountedPrice);
  if (!Number.isNaN(discountedPrice) && discountedPrice > 0) {
    return discountedPrice;
  }

  const planPrice = Number(plan.planPrice);
  if (!Number.isNaN(planPrice) && planPrice > 0) {
    return planPrice;
  }

  if (discountedPrice === 0 || planPrice === 0) {
    return 0;
  }

  return null;
};

export const pickAllInOnePlan = (
  subscriptionPlans = [],
  { planId, frequency, preferredPlanCode = "JO0001" } = {},
) => {
  if (!subscriptionPlans.length) {
    return null;
  }

  const targetFreq = frequency ? String(frequency).toUpperCase() : null;
  const byId = planId
    ? subscriptionPlans.find((plan) => Number(plan.planId) === Number(planId))
    : null;

  if (byId && (!targetFreq || byId.planFrequency === targetFreq)) {
    return byId;
  }

  if (targetFreq) {
    const planCode = byId?.planCode || preferredPlanCode;
    return (
      subscriptionPlans.find(
        (plan) =>
          plan.planFrequency === targetFreq && plan.planCode === planCode,
      ) ||
      subscriptionPlans.find((plan) => plan.planFrequency === targetFreq) ||
      byId ||
      subscriptionPlans.find((plan) => plan.planCode === preferredPlanCode) ||
      subscriptionPlans[0]
    );
  }

  return (
    byId ||
    subscriptionPlans.find((plan) => plan.planCode === preferredPlanCode) ||
    subscriptionPlans[0]
  );
};

export const buildAvailablePlansForSelection = (
  plan,
  subscriptionPlans = [],
  { isAllInOne = false, isAllInOneSubscriber = false, preferredFrequency = null } = {},
) => {
  if (!plan || !subscriptionPlans.length) {
    return [];
  }

  const productCode = plan.productMap?.[0]?.productCode;
  let availablePlans = subscriptionPlans
    .filter((sp) => {
      if (isAllInOne || productCode === "ALLINONE" || isAllInOneSubscriber) {
        return true;
      }
      return sp?.planCode === plan.planCode;
    })
    .reverse();

  if (isAllInOne || productCode === "ALLINONE" || isAllInOneSubscriber) {
    const lockedFreq = preferredFrequency
      ? String(preferredFrequency).toUpperCase()
      : null;
    const uniqueFrequencies =
      lockedFreq === "YEARLY" || lockedFreq === "HALF_YEARLY"
        ? [lockedFreq]
        : ["HALF_YEARLY", "YEARLY"];
    const filteredPlans = [];

    uniqueFrequencies.forEach((freq) => {
      let match = availablePlans.find(
        (p) => p.planFrequency === freq && p.planCode === plan.planCode,
      );
      if (!match) {
        match = availablePlans.find((p) => p.planFrequency === freq);
      }
      if (match) {
        filteredPlans.push(match);
      }
    });

    availablePlans = filteredPlans.length ? filteredPlans : availablePlans;
  }

  return availablePlans;
};
